export const TabName = {
  General: "General",
  Structure: "Structure",
  Payments: "Payments",
  Tax: "Tax",
  Groups: "Groups",
  Sinonyms: "Sinonyms",
  Currency: "Currency",
  Quotes: "Quotes",
  Agencies: "Agencies",
  Portfolios: "Portfolios",
  Denominations: "Denominations",
  Fundamentals: "Fundamentals",
};

export const DayCountFractions = {
  ACTISDA: "ACTISDA",
  ACT365: "ACT365",
  ACT360: "ACT360",
  ACTISMA: "ACTISMA",
  ACTAFB: "ACTAFB",
  BOND30360: "BOND30360",
  EU30360: "30E/360",
  ISDA30360: "30E/360 (ISDA)",
  BOND30365: "BOND30365",
  ACTPY: "ACTPY",
};

export const PaymentBase = {
  Days: "Days",
  Weeks: "Weeks",
  Months: "Months",
  Years: "Years",
};

export const PaymentFormula = {
  InterestRate: "Interest Rate",
  ZeroCoupon: "Zero Coupon",
  Dividend: "Dividend",
  DiscountSimple: "Discount Simple",
  DiscountCompound: "Discount Compound",
  EffectiveRate: "Effective Rate",
  None: "None",
};

export const IndexType = {
  None: "None",
  OnlyPrincipal: "Only Principal",
  OnlyPayments: "Only Payments",
  PrincipalAndPayments: "Principal And Payments",
};

export const CallPut = {
  Call: "Call",
  Put: "Put",
};

export const IssuanceType = {
  Global: "Global",
  Local: "Local",
  Foreign: "Foreign",
};

export const SectorType = {
  Sovereign: "Sovereign",
  Public: "Public",
  Private: "Private",
};

export const OfferType = {
  Public: "Public",
  Private: "Private",
};

export const PaymentRateType = {
  Fixed: "Fixed",
  Variable: "Variable",
};

export const FundType = {
  Open: "Open",
  Close: "Close",
};

export const YesNo = {
  Yes: 1,
  No: 0,
};

export const QuotingType = {
  Units: "Units",
  Percentage: "Percentage",
  Contracts: "Contracts",
};

export const Mode = {
  Insert: "INS",
  Update: "UPD",
  Delete: "DLT",
};

export const WizzMode = {
  New: "new",
  Edit: "edit",
  View: "view",
  Quotes: "quotes",
};

export const Decimals = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
};

export const TaxType = {
  VAT: "VAT",
  INCOME: "INCOME",
  MARKETWTAX: "MARKETWTAX",
};

export const SinkType = {
  Face: "Original face",
  Remaining: "Remaining",
};

export const AssetStatus = {
  Active: "Active",
  Inactive: "Inactive",
  InProcess: "InProcess",
  Deleted: "Deleted",
  Blocked: "Blocked",
  Matured: "Matured",
};

export const DenominationStatus = {
  Active: "Active",
  Inactive: "Inactive",
};

export const DPEditing = {
  None: "None",
  Both: "Both",
  OnlyValue: "OnlyValue",
};
